export const endPoints = {
  CONTRACT_QR: '/v1/contract/qr/'
};
